/**
 * Navigation Components Index
 *
 * Phase 3.2: QuickNav Component
 *
 * Exports:
 * - QuickNav: Sticky horizontal chip navigation
 * - QuickNavChip: Individual navigation chip
 * - useScrollToSection: Hook for scroll management
 */

export { QuickNav, SECTION_CONFIGS } from './QuickNav';
export { QuickNavChip } from './QuickNavChip';
export {
  useScrollToSection,
  QUICKNAV_TOP_OFFSET,
  type SectionId,
} from './useScrollToSection';
